import * as React from "react";
import {
  Tooltip,
  withStyles,
  ClickAwayListener,
} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import Typography from "@material-ui/core/Typography";

const styles = (theme) => ({
  demoBanner: {
    top: 0,
    left: 0,
    width: "100%",
    padding: 5,
    textAlign: "center",
    fontSize: 14,
    background: "rgb(31 170 114 / 15%)",
    zIndex: 999,
    "&.light": {
      background: theme.palette.common.white,
    },
    "& .MuiTooltip-popper": {
      pointerEvents: "all",
    },
    "& a": {
      textDecoration: "underline",
      color: theme.palette.primary.main,
      fontWeight: 500,
    },
  },
  tooltip: {
    background: theme.palette.primary.contrastText,
    border: `1px solid ${theme.palette.secondary.lightGray}`,
    color: theme.palette.secondary.charcoal,
    boxShadow: theme.shadows[1],
    opacity: 1,
    fontSize: 13,
    textAlign: "left",
    [theme.breakpoints.down("md")]: {
      paddingBottom: 30,
    },
  },
});

const DemoBanner = (props) => {
  const [open, setOpen] = React.useState(false);
  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
  };

  const { classes, light } = props;
  return (
    <div className={`${classes.demoBanner} ${light ? "light" : ""}`}>
      <Typography paragraph={false} color={light ? "primary" : "textPrimary"}>
        <b>Cy Demo</b>
        <ClickAwayListener onClickAway={handleTooltipClose}>
          <Tooltip
            placement="bottom"
            PopperProps={{
              disablePortal: true,
            }}
            classes={{ tooltip: classes.tooltip }}
            onClose={handleTooltipClose}
            open={open}
            disableFocusListener
            disableHoverListener
            disableTouchListener
            title={
              <span>
                This is a demonstration version of Cy. For full functionality
                visit{" "}
                <a href="https://investwithcy.com" rel="noopener noreferrer">
                  investwithcy.com
                </a>
              </span>
            }
          >
            <IconButton onClick={handleTooltipOpen} size={"small"}>
              <ErrorOutlineIcon
                fontSize={"inherit"}
                color={light ? "primary" : "inherit"}
              />
            </IconButton>
          </Tooltip>
        </ClickAwayListener>
      </Typography>
    </div>
  );
};

export default withStyles(styles)(DemoBanner);



// WEBPACK FOOTER //
// ./src/components/DemoBanner/index.jsx